export default "__VITE_ASSET__CINADPFf__"